/*************************************************************************
 *
 * c20g CONFIDENTIAL
 * __________________
 *
 *  [2007] - [2021] Counterpoint Consulting, Incorporated
 *  All Rights Reserved.
 *
 * NOTICE:  All information contained herein is, and remains
 * the property of Counterpoint Consulting Incorporated.
 * The intellectual and technical concepts contained
 * herein are proprietary to Counterpoint Consulting Incorporated
 * and its suppliers and may be covered by U.S. and Foreign Patents,
 * patents in process, and are protected by trade secret or copyright law.
 * Dissemination of this information or reproduction of this material
 * is strictly forbidden unless prior written permission is obtained
 * from Counterpoint Consulting Incorporated.
 */

import cleanUpResponse from '@/util/cleanUpResponse';

export default async function GetAWPackageFDRInfo(awPackageId) {
  const response = await $.soap({
    body: {
      GetAWPackageFDRInfo: {
        $xmlns: 'http://dla.mil/ems/bpm/aw_package',
        AWPackageID: awPackageId
      }
    },
    blueprint: {
      id: '$..ID',
      prNumber: '$..PRNum',
      frNumber: '$..FRNum',
      vendorCode: '$..VendorCode',
      fundingCategoryId: '$..FundingCategoryID',
      koName: '$..KOName',
      pgr: '$..KOPGr',
      pgcCode: '$..PGCCode',
      pocFirstName: '$..KOPOCFirstName',
      pocLastName: '$..KOPOCLastName',
      pocEmail: '$..KOPOCEmail',
      pocPhone: '$..KOPOCPhone',
      pocFax: '$..KOPOCFax',
      address: {
        address1: '$..Address1',
        buildingFloorNumber: '$..BuildingFloorNumber',
        roomPoleNumber: '$..RoomPoleNumber',
        city: '$..City',
        zip: '$..Zip',
        regionId: '$..RegionID'
      }
    }
  });
  cleanUpResponse(response);
  return response;
}
